import { Tooltip } from '@ets/design-system';
import { useIntl } from 'react-intl';

type StandardTooltipWidgetProps = {
  testId: string;
  content: string;
  isFieldInMultiline: boolean;
  shortcut?: string;
  children: React.ReactNode;
};

const StandardTooltipWidgetView = ({
  testId,
  content,
  shortcut,
  isFieldInMultiline,
  children,
}: StandardTooltipWidgetProps) => {
  const intl = useIntl();

  return (
    <Tooltip
      testId={testId}
      content={
        shortcut
          ? intl.formatMessage({ id: content }, { shortcut })
          : intl.formatMessage({ id: content })
      }
      open={true}
      placement={isFieldInMultiline ? 'right' : 'top'}
    >
      {children}
    </Tooltip>
  );
};

export default StandardTooltipWidgetView;
